import Vue from 'vue'
import axios from 'axios'
import {store} from '../store'

export function createAxios(apiToken) {
	const locationPath = location.pathname.split('/')
	const axiosInstance = axios.create({
		headers: {
			'Content-Type': 'application/json',
			accept: 'application/json',
			Authorization: 'Bearer ' + apiToken,
			"Accept-School-Type": 'academic',
			'Accept-Currency': localStorage.getItem('currencyCode') ? localStorage.getItem('currencyCode') : store.getters['global/currencyGetter'],
			'Accept-Language': (locationPath.includes('az') || locationPath.includes('en')) && locationPath[1] ? locationPath[1] : 'tr'
		}
	})

	axiosInstance.interceptors.response.use(
		(response) => {
			return response
		},
		(error) => {
			if(error.response.status === 419) {
				$("#csrfModal").modal('show');
			}
			if (error.response.data && error.response.data.errors || error.response.data && error.response.data.result && error.response.data.result.errors) {
				const errors = error.response.data.errors || error.response.data.result.errors
				Object.keys(errors).forEach(err => {
					Vue.toasted.show(errors[err][0], {
						theme: "bubble",
						class: 'error-notification',
						position: "top-right",
						duration: 3000
					})
				})
			}
			throw error
		}
	)

	return axiosInstance
}
